import { useState, Fragment } from "react";
import { requestPartnerAPI } from "../../api/server";
import LoadingSpinner from "../UI/LoadingSpinner";
import Heading from "../UI/Heading";

export default function Business({ setProgress }) {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("individual");

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let payload = {};
      if (type === "individual") {
        payload = {
          type,
          address: e.target.address.value,
        };
      } else {
        payload = {
          type,
          businessName: e.target.businessName.value,
          ein: e.target.ein.value,
          businessAddress: e.target.businessAddress.value,
          address: e.target.address.value,
        };
      }
      await requestPartnerAPI("edit-partner", payload);
      setProgress((progress) => progress + 1);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const classNames = (selected) => {
    let classes =
      "p-2 text-center border-2 rounded-lg hover:border-yellow-900 cursor-pointer";
    if (selected === type) classes += " bg-yellow-800 border-yellow-900";
    else classes += " bg-stone-600 border-stone-700";
    return classes;
  };

  return (
    <form
      onSubmit={submitHandler}
      className="grid items-center content-start gap-4 md:grid-cols-2 text-stone-200"
    >
      <div className="grid gap-2 lg:col-span-2">
        <Heading
          title="Business / Individual"
          description="Choose whether the vehicles in this account will be under your personal name or business."
        />
      </div>
      <div className="grid gap-2 lg:col-span-2">
        <p>Are you setting this up as an individual or business account?</p>
        <div className="grid grid-cols-2 gap-4">
          <div
            onClick={() => setType("individual")}
            className={classNames("individual")}
          >
            <p className="">Individual</p>
          </div>
          <div
            onClick={() => setType("business")}
            className={classNames("business")}
          >
            <p>Business</p>
          </div>
        </div>
      </div>

      {type === "individual" ? (
        <div className="grid gap-1 md:col-span-2">
          <label className="form-label">Home Address:</label>
          <input className="form-input" name="address" required />
        </div>
      ) : (
        <Fragment>
          <div className="grid gap-1">
            <label className="form-label">Business Name:</label>
            <input className="form-input" name="businessName" required />
          </div>
          <div className="grid gap-1">
            <label className="form-label">EIN:</label>
            <input className="form-input" name="ein" />
          </div>
          <div className="grid gap-1 md:col-span-2">
            <label className="form-label">Business Address:</label>
            <input className="form-input" name="businessAddress" required />
          </div>
          <div className="grid gap-1 md:col-span-2">
            <label className="form-label">Home Address:</label>
            <input className="form-input" name="address" required />
          </div>
        </Fragment>
      )}

      {loading ? (
        <LoadingSpinner />
      ) : (
        <button type="submit" className="mt-4 text-sm btn-primary">
          Continue
        </button>
      )}
    </form>
  );
}
